import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chief-complaints',
  templateUrl: './chief-complaints.component.html',
  styleUrls: ['./chief-complaints.component.css']
})
export class ChiefComplaintsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
